import {useMutation} from '@tanstack/react-query'
import {httpResendVerificationPhoneCode} from '@features/settings/http/settings.http.ts'
import {errorHandler} from '@utilities/helpers.ts'

export const useResendVerificationPhoneCode = ({onSuccess}: {onSuccess: () => void}) => {
    return useMutation({
        mutationFn: () => httpResendVerificationPhoneCode(),
        onError: errorHandler,
        onSuccess
    })
}
